import FAQArticle from '../../../faq/src/models/FAQArticle';

export default class SearchResult {
    public totalNumberOfSearchResults: number;
    public page: number;
    public searchResults: SearchResultItem[];
    public faqs: FAQArticle[];

    constructor(init?: Partial<SearchResult>){
        Object.assign(this, init);
    }
}

export class SearchResultItem {
    public title: string;
    public content: string;
    public type: string;
    public url: string;
    public score: number;
}